<template>
    <v-container fluid class="fill-height">
        <template v-if="json.length != 0">
            <v-menu
                v-model="addMenu"
                :position-x="x"
                :position-y="y"
                absolute
                offset-y
                :close-on-content-click="false"
                max-width="120"
            >
                <v-container fluid style="background-color: #FFF">
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field
                                label="宽度"
                                v-model="json[divindex].style.width"
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                label="字体大小"
                                v-model="json[divindex].style.fontSize"
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-label>文字颜色</v-label>
                        </v-col>
                        <v-col cols="12" md="4">
                            <el-color-picker v-model="json[divindex].style.color"></el-color-picker>
                        </v-col>

                    </v-row>
                </v-container>
            </v-menu>

        </template>
        <div class="contain" id="printTest" ref="dragContain">

            <div v-drag="contain" class="drag" :class="{active:index == divindex}" v-if="json.length"
                 v-for="(item,index) in json" @click="moveDiv(index,$event)" :style="item.style"
                 @contextmenu.prevent="showAddMenu(index,$event)"
            >
                {{item.text}}
            </div>
            <div class="drag"
                 style="fontSize: 15px;color:rgb(0, 0, 0);top:10px; left: 10px;backgroundColor:rgba(255, 255, 255, 0);">
                学生名字:
            </div>
            <div class="drag"
                 style="fontSize: 15px;color:rgb(0, 0, 0);top:70px; left: 10px;backgroundColor:rgba(255, 255, 255, 0);">
                学校简称:
            </div>
            <div class="drag"
                 style="fontSize: 15px;color:rgb(0, 0, 0);top:130px;left: 10px;backgroundColor:rgba(255, 255, 255, 0);">
                上次成绩:
            </div>
            <div class="drag"
                 style="fontSize: 15px;color:rgb(0, 0, 0);top:190px;left: 10px;backgroundColor:rgba(255, 255, 255, 0);">
                本次成绩:
            </div>
            <div class="drag"
                 style="fontSize: 15px;color:rgb(0, 0, 0);top:250px;left: 10px;backgroundColor:rgba(255, 255, 255, 0);">
                上次排名:
            </div>
            <div class="drag"
                 style="fontSize: 15px;color:rgb(0, 0, 0);top:310px;left: 10px;backgroundColor:rgba(255, 255, 255, 0);">
                本次排名:
            </div>
        </div>
        <v-btn v-5="permissionCode.save" @click="onSave">保存模板</v-btn>
        <v-btn v-5="permissionCode.reset" @click="reset">恢复默认</v-btn>
    </v-container>
</template>

<script>
    import {ColorPicker} from '@/plugins/element'
    import arrayUtil from "@/utils/util/ArrayUtil"

    export default {
        name: "PersonnelTemplate",
        data() {
            return {
                permissionCode:{
                    save:'biz:ptemplate:save',
                    reset:'biz:ptemplate:reset',
                },
                addMenu: false,
                colorMenu:false,
                colorMode:"hexa",
                json:[{
                    "style": {
                        "width": "60px",
                        "height": "80px",
                        "fontSize": "26px",
                        "color": "#000000FF",
                        "border": "1px solid rgb(0, 0, 0)",
                        "backgroundColor": "rgb(255, 255, 255)",
                        "textAlign": "center",
                        "left": "500px",
                        "top": "310px",
                        "borderRadius": "5px"
                    },
                    "text": "",
                    "isText": false
                }],
                defJson: [{
                    "style": {
                        "width": "60px",
                        "height": "80px",
                        "fontSize": "26px",
                        "color": "#000000FF",
                        "border": "1px solid rgb(0, 0, 0)",
                        "backgroundColor": "rgb(255, 255, 255)",
                        "textAlign": "center",
                        "left": "500px",
                        "top": "310px",
                        "borderRadius": "5px"
                    },
                    "text": "",
                    "isText": false
                }, {
                    "style": {
                        width:"60px",
                        "fontSize": "15px",
                        "color": "#000000FF",
                        "top": "10px",
                        "left": "90px",
                        "border": "none",
                        "textAlign": "center",
                        "backgroundColor": "rgba(255, 255, 255, 0)"
                    },
                    "text": "宫本武藏",
                    "key": "name",
                    "isText": true
                }, {
                    "style": {
                        width:"78px",
                        "fontSize": "13px",
                        "color": "#000000FF",
                        "top": "70px",
                        "left": "90px",
                        "border": "none",
                        "textAlign": "center",
                        "backgroundColor": "rgba(255, 255, 255, 0)"
                    },
                    "text": "济南青岛",
                    "key": "school",
                    "isText": true
                }, {
                    "style": {
                        width:"25.228px",
                        "fontSize": "15px",
                        "color": "#000000FF",
                        "top": "130px",
                        "left": "90px",
                        "border": "none",
                        "textAlign": "center",
                        "backgroundColor": "rgba(255, 255, 255, 0)"
                    },
                    "text": "100",
                    "key": "lastResult",
                    "isText": true
                }, {
                    "style": {
                        width:"25.228px",
                        "fontSize": "15px",
                        "color": "#000000FF",
                        "top": "190px",
                        "left": "90px",
                        "border": "none",
                        "textAlign": "center",
                        "backgroundColor": "rgba(255, 255, 255, 0)"
                    },
                    "text": "100",
                    "key": "result",
                    "isText": true
                }, {
                    "style": {
                        width:"25.228px",
                        "fontSize": "15px",
                        "color": "#000000FF",
                        "top": "250px",
                        "left": "90px",
                        "border": "none",
                        "textAlign": "center",
                        "backgroundColor": "rgba(255, 255, 255, 0)"
                    },
                    "text": "100",
                    "key": "lastRank",
                    "isText": true
                },{
                    "style": {
                        width:"25.228px",
                        "fontSize": "15px",
                        "color": "#000000FF",
                        "top": "310px",
                        "left": "90px",
                        "border": "none",
                        "textAlign": "center",
                        "backgroundColor": "rgba(255, 255, 255, 0)"
                    },
                    "text": "100",
                    "key": "rank",
                    "isText": true
                }],
                //json:[{"style":{"width":"210px","height":"50px","fontSize":"26px","color":"rgb(0, 0, 0)","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","textAlign":"center","left":"450px","top":"720px","borderRadius":"5px"},"text":"讲台","delShow":false},{"style":{"width":"80px","height":"40px","fontSize":"14px","color":"rgb(255, 255, 255)","top":"610px","left":"10px","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","borderRadius":"5px"},"text":"","delShow":true},{"style":{"width":"80px","height":"40px","fontSize":"14px","color":"rgb(255, 255, 255)","top":"610px","left":"90px","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","borderRadius":"5px"},"text":"","delShow":true},{"style":{"width":"80px","height":"40px","fontSize":"14px","color":"rgb(255, 255, 255)","top":"610px","left":"170px","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","borderRadius":"5px"},"text":"","delShow":true},{"style":{"width":"80px","height":"40px","fontSize":"14px","color":"rgb(255, 255, 255)","top":"610px","left":"570px","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","borderRadius":"5px"},"text":"","delShow":true},{"style":{"width":"80px","height":"40px","fontSize":"14px","color":"rgb(255, 255, 255)","top":"610px","left":"330px","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","borderRadius":"5px"},"text":"","delShow":true},{"style":{"width":"80px","height":"40px","fontSize":"14px","color":"rgb(255, 255, 255)","top":"610px","left":"410px","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","borderRadius":"5px"},"text":"","delShow":true},{"style":{"width":"80px","height":"40px","fontSize":"14px","color":"rgb(255, 255, 255)","top":"610px","left":"490px","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","borderRadius":"5px"},"text":"","delShow":true},{"style":{"width":"80px","height":"40px","fontSize":"14px","color":"rgb(255, 255, 255)","top":"610px","left":"970px","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","borderRadius":"5px"},"text":"","delShow":true},{"style":{"width":"80px","height":"40px","fontSize":"14px","color":"rgb(255, 255, 255)","top":"610px","left":"730px","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","borderRadius":"5px"},"text":"","delShow":true},{"style":{"width":"80px","height":"40px","fontSize":"14px","color":"rgb(255, 255, 255)","top":"610px","left":"810px","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","borderRadius":"5px"},"text":"","delShow":true},{"style":{"width":"80px","height":"40px","fontSize":"14px","color":"rgb(255, 255, 255)","top":"610px","left":"890px","border":"1px solid rgb(0, 0, 0)","backgroundColor":"rgb(255, 255, 255)","borderRadius":"5px"},"text":"","delShow":true}],
                name: "",
                //菜单位置
                x: 0,
                y: 0,
                //块位置
                offsetX: 0,
                offsetY: 0,
                //外层容器的宽高 数值不带px单位
                contain: {
                    xx: 500,
                    yy: 500
                },
                //存放拉伸放大时的  div的原始宽高 带px单位
                movejson: {
                    moveWidth: '',
                    moveHeight: ''
                },
                divindex: 0,//当前选中div的序号  默认为0
            }
        },
        mounted() {
            this.contain.xx = this.$refs.dragContain.offsetWidth;
            this.contain.yy = this.$refs.dragContain.offsetHeight;
            this.$api.sysSetting.selectSetting("persontemplet").then(data=>{
                if(!data.data.v){
                    this.json = arrayUtil.deepClone(this.defJson);
                }else{
                    let value = JSON.parse(data.data.v);
                    for(let obj of value){
                        obj.style.top = parseInt(this.json[0].style.top) +parseInt(obj.style.top) + "px";
                        obj.style.left = parseInt(this.json[0].style.left) +parseInt(obj.style.left) + "px";
                        this.json.push(obj);
                    }
                }
            })
        },
        methods: {
            // 字符串转json对象
            toJson(str) {
                let _str = eval('(' + str + ')');
                return _str;
            },
            //外层div点击选择事件 绑定右上角设置面板
            moveDiv(index, e) {
                let jsonNew = this.toJson('{"' + e.target.style.cssText.replace(/\; +/g, "\",\"").replace(/\: +/g, "\":\"").replace(/\;+/g, "").replace(/-\w/g, function ($) {
                    return $.slice(1).toUpperCase();
                }) + '"}');
                //当前选中div的序号
                this.divindex = index;

                // 设置div框的 各种属性
                for (let em in jsonNew) {
                    this.json[index].style[em] = jsonNew[em];
                }
                this.json[index].text = e.target.innerText;

            },
            addText() {
                let newJson = {
                    style: {
                        //width: "100%",
                        //height: "100%",
                        fontSize: "12px",
                        color: "#000",
                        top: "0px",
                        left: "0px",
                        border: "none",
                        backgroundColor: "rgba(255, 255, 255, 0)"
                    },
                    text: "名字"
                };
                this.json.push(newJson);
            },
            //删除当前div
            del(i, e) {
                this.json.splice(i, 1);
                // console.log(i,this.json.length)
                if (i == this.json.length) {
                    this.divindex = 0;
                }
                e.stopPropagation();
            },
            onSave() {
                // console.log(this.json,'11')
                let data = this.json[0];
                let originLeft = parseInt(data.style.left);
                let originTop = parseInt(data.style.top);
                let returnJson = [];
                let copyJson = arrayUtil.deepClone(this.json);
                for (let i = 1; i < copyJson.length; i++) {
                    let obj = copyJson[i];
                    obj.style.left = parseInt(obj.style.left) - originLeft + "px";
                    obj.style.top = parseInt(obj.style.top) - originTop + "px";
                    returnJson.push(obj)
                }
                this.$api.sysSetting.updateSetting({
                    k:"persontemplet",
                    v:JSON.stringify(returnJson)
                }).then(result=>{
                    if(result.flag){
                        this.$dialog.alert("修改成功");
                        this.$router.push("/room");
                    }
                });
            },
            //div上拉伸的阻止冒泡事件
            sacle(e) {
                e.stopPropagation();
            },
            showAddMenu(index, e) {
                this.x = e.clientX
                this.y = e.clientY
                this.offsetX = e.offsetX
                this.offsetY = e.offsetY
                this.addMenu = true
                this.divindex = index
            },
            reset(){
                this.json = [];
                this.json = arrayUtil.deepClone(this.defJson);
            },
        },
        components:{
            ColorPicker
        },
        computed: {},
        directives: {
            drag: {
                bind: function (el, binding, vnode) {
                    el.onmousedown = (e) => {
                        var disx = e.clientX - el.offsetLeft;
                        var disy = e.clientY - el.offsetTop;
                        document.onmousemove = function (e) {
                            let left = e.clientX - disx;
                            let top = e.clientY - disy;
                            if (left < 0) {
                                left = 0;
                            }
                            if (top < 0) {
                                top = 0;
                            }
                            if (left > binding.value.xx - el.offsetWidth) {
                                left = binding.value.xx - el.offsetWidth;
                            }
                            if (top > binding.value.yy - el.offsetHeight) {
                                top = binding.value.yy - el.offsetHeight;
                            }
                            //left = Math.floor((left + 5) / 10) * 10;
                            //top = Math.floor((top + 5) / 10) * 10;
                            el.style.left = left + 'px';
                            el.style.top = top + 'px';
                        }
                        document.onmouseup = function () {
                            document.onmousemove = document.onmouseup = null;
                        }
                    }

                },

            }
        }
    }
</script>

<style lang='scss' scoped>
    ul, li {
        margin: 0px;
        list-style: none;
        padding: 0px;
    }

    .contain {
        height: 209.8mm;
        position: relative;
        user-select: none;
        width: 297mm;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
    }

    .el-form-item--mini.el-form-item {
        margin-bottom: 7px;
    }

    .drag {
        //width: 100px;
        //height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        cursor: move;
        background-color: red;
        border: 1px solid #FFF;
        //line-height: 1.7;
        box-sizing: border-box;
        color: #fff;
        overflow: hidden;
        //padding: 5px;

        .sacle {
            position: absolute;
            right: 0px;
            bottom: 0px;
            background-color: #909399;
            cursor: se-resize;
            font-size: 15px;
        }

        .del {
            position: absolute;
            top: 0px;
            right: 0px;
            padding: 2px;
            box-shadow: none;
        }
    }

    .drag.active {
        border-radius: 5px;
        border: 1px solid #85ce61;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);

    }

    .control {
        width: 250px;
        border-radius: 5px;
        overflow: hidden;
        background-color: #B3C0D1;
        position: absolute;
        z-index: 999;
        right: 20px;
        top: 15px;
    }
</style>

